import React from "react";
import "./styles/loading.scss";

type LoadingSkeletonType = {
  isUploadFile?: boolean;
}

const LoadingSkeleton = (props: LoadingSkeletonType) => {
  const {isUploadFile} = props
  return (
    <>
      <figure className={isUploadFile ? "file-loader" : "loader"}>
        <div className="dot white"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </figure>
      <div className="text_data-loading">
        <h6>{isUploadFile ?  "Đang tải tập tin..." : "Đang tải dữ liệu..."}</h6>
      </div>
    </>
  );
};

export default LoadingSkeleton;
